import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "32",
      height: "32",
      fill: "currentColor",
      "fill-opacity": ".18",
      rx: "3"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16 6.25A9.75 9.75 0 1 0 25.75 16 9.76 9.76 0 0 0 16 6.25m-.375 4.5a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25m1.125 10.5a1.5 1.5 0 0 1-1.5-1.5V16a.75.75 0 1 1 0-1.5 1.5 1.5 0 0 1 1.5 1.5v3.75a.75.75 0 1 1 0 1.5"
    }, null, -1)
  ])))
}
export default { render: render }